import { useEffect, useState } from 'react';
import { getRecuiterById } from '../Services/RecruiterService';

/**
 * Whether the signed-in recruiter administers their company workspace.
 *
 * <p>The flag lives on the recruiter record (`is_company_admin_user`), not on the
 * user record, so it cannot be read from {@link storage} the way the role can -
 * every consumer has to ask the server. The dashboard payload happens to carry
 * it already (`profile.companyAdmin`) and reads it directly; this hook is for
 * the surfaces that render outside the dashboard, such as the header navigation
 * and the subscription plans page itself.</p>
 *
 * <p>Defaults to false and only turns true once the server says so. A recruiter
 * who is not a company admin has nothing to purchase on, so hiding the entry is
 * also cheaper than rendering a page the server would reject.</p>
 */
export const useCompanyAdminAccess = () => {
  const [isCompanyAdminUser, setIsCompanyAdminUser] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      try {
        const res = await getRecuiterById();
        if (!cancelled && res.success && res.data) {
          setIsCompanyAdminUser(Boolean(res.data.isCompanyAdminUser));
        }
      } catch {
        // Leave it false: a failed check must not expose a company-only surface.
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { isCompanyAdminUser, loading };
};